module.exports = __webpack_public_path__ + "img/red_exclamation_mark.3c33c8e3.png";